
import { singleton, ofArray, tail, head, isEmpty, filter } from "./fable_modules/fable-library-js.5.3.0/List.js";
import { ClientTypes_Route } from "./Shared/ClientTypes.js";
import { split, printf, toText } from "./fable_modules/fable-library-js.5.3.0/String.js";
import { item } from "./fable_modules/fable-library-js.5.3.0/Array.js";
import { ofNullable, map } from "./fable_modules/fable-library-js.5.3.0/Option.js";
import { RouterModule_nav, RouterModule_urlSegments } from "./Vendor/FelizRouter.js";
import { Operators_IsNull } from "./fable_modules/fable-library-js.5.3.0/FSharp.Core.js";

export function parseUrl(segments) {
    const cleanSegments = filter((s) => !s.startsWith("?"), segments);
    let matchResult, slug, id, id_1, id_2, userId, id_3;
    if (!isEmpty(cleanSegments)) {
        switch (head(cleanSegments)) {
            case "challenges": {
                if (!isEmpty(tail(cleanSegments))) {
                    if (head(tail(cleanSegments)) === "new") {
                        if (!isEmpty(tail(tail(cleanSegments)))) {
                            switch (head(tail(tail(cleanSegments)))) {
                                case "charity": {
                                    if (!isEmpty(tail(tail(tail(cleanSegments))))) {
                                        if (isEmpty(tail(tail(tail(tail(cleanSegments)))))) {
                                            matchResult = 3;
                                            slug = head(tail(tail(tail(cleanSegments))));
                                        }
                                        else {
                                            matchResult = 17;
                                        }
                                    }
                                    else {
                                        matchResult = 17;
                                    }
                                    break;
                                }
                                case "pledges": {
                                    if (isEmpty(tail(tail(tail(cleanSegments))))) {
                                        matchResult = 4;
                                        id = head(tail(cleanSegments));
                                    }
                                    else {
                                        matchResult = 17;
                                    }
                                    break;
                                }
                                case "logs": {
                                    if (isEmpty(tail(tail(tail(cleanSegments))))) {
                                        matchResult = 5;
                                        id_1 = head(tail(cleanSegments));
                                    }
                                    else {
                                        matchResult = 17;
                                    }
                                    break;
                                }
                                default:
                                    matchResult = 17;
                            }
                        }
                        else {
                            matchResult = 2;
                        }
                    }
                    else if (isEmpty(tail(tail(cleanSegments)))) {
                        matchResult = 6;
                        id_2 = head(tail(cleanSegments));
                    }
                    else {
                        switch (head(tail(tail(cleanSegments)))) {
                            case "pledges": {
                                if (isEmpty(tail(tail(tail(cleanSegments))))) {
                                    matchResult = 4;
                                    id = head(tail(cleanSegments));
                                }
                                else {
                                    matchResult = 17;
                                }
                                break;
                            }
                            case "logs": {
                                if (isEmpty(tail(tail(tail(cleanSegments))))) {
                                    matchResult = 5;
                                    id_1 = head(tail(cleanSegments));
                                }
                                else {
                                    matchResult = 17;
                                }
                                break;
                            }
                            default:
                                matchResult = 17;
                        }
                    }
                }
                else {
                    matchResult = 1;
                }
                break;
            }
            case "profile": {
                if (!isEmpty(tail(cleanSegments))) {
                    if (head(tail(cleanSegments)) === "complete") {
                        if (isEmpty(tail(tail(cleanSegments)))) {
                            matchResult = 8;
                        }
                        else {
                            matchResult = 17;
                        }
                    }
                    else {
                        matchResult = 17;
                    }
                }
                else {
                    matchResult = 7;
                }
                break;
            }
            case "auth": {
                if (!isEmpty(tail(cleanSegments))) {
                    if (head(tail(cleanSegments)) === "callback") {
                        if (isEmpty(tail(tail(cleanSegments)))) {
                            matchResult = 9;
                        }
                        else {
                            matchResult = 17;
                        }
                    }
                    else {
                        matchResult = 17;
                    }
                }
                else {
                    matchResult = 17;
                }
                break;
            }
            case "register": {
                if (isEmpty(tail(cleanSegments))) {
                    matchResult = 10;
                }
                else {
                    matchResult = 17;
                }
                break;
            }
            case "verify": {
                if (!isEmpty(tail(cleanSegments))) {
                    if (isEmpty(tail(tail(cleanSegments)))) {
                        matchResult = 11;
                        userId = head(tail(cleanSegments));
                    }
                    else {
                        matchResult = 17;
                    }
                }
                else {
                    matchResult = 17;
                }
                break;
            }
            case "pledges": {
                if (!isEmpty(tail(cleanSegments))) {
                    if (isEmpty(tail(tail(cleanSegments)))) {
                        matchResult = 12;
                        id_3 = head(tail(cleanSegments));
                    }
                    else {
                        matchResult = 17;
                    }
                }
                else {
                    matchResult = 17;
                }
                break;
            }
            case "privacy": {
                if (isEmpty(tail(cleanSegments))) {
                    matchResult = 13;
                }
                else {
                    matchResult = 17;
                }
                break;
            }
            case "terms": {
                if (isEmpty(tail(cleanSegments))) {
                    matchResult = 14;
                }
                else {
                    matchResult = 17;
                }
                break;
            }
            case "refunds": {
                if (isEmpty(tail(cleanSegments))) {
                    matchResult = 15;
                }
                else {
                    matchResult = 17;
                }
                break;
            }
            case "flood-relief": {
                if (isEmpty(tail(cleanSegments))) {
                    matchResult = 16;
                }
                else {
                    matchResult = 17;
                }
                break;
            }
            default:
                matchResult = 17;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return new ClientTypes_Route(0, []);
        case 1:
            return new ClientTypes_Route(1, []);
        case 2:
            return new ClientTypes_Route(3, []);
        case 3:
            return new ClientTypes_Route(4, [slug]);
        case 4:
            return new ClientTypes_Route(11, [id]);
        case 5:
            return new ClientTypes_Route(12, [id_1]);
        case 6:
            return new ClientTypes_Route(2, [id_2]);
        case 7:
            return new ClientTypes_Route(5, []);
        case 8:
            return new ClientTypes_Route(6, []);
        case 9:
            return new ClientTypes_Route(7, []);
        case 10:
            return new ClientTypes_Route(8, []);
        case 11:
            return new ClientTypes_Route(9, [userId]);
        case 12:
            return new ClientTypes_Route(10, [id_3]);
        case 13:
            return new ClientTypes_Route(13, []);
        case 14:
            return new ClientTypes_Route(14, []);
        case 15:
            return new ClientTypes_Route(15, []);
        case 16:
            return new ClientTypes_Route(16, []);
        default:
            return new ClientTypes_Route(0, []);
    }
}

export function formatPath(route) {
    switch (route.tag) {
        case 1:
            return "/challenges";
        case 2:
            return toText(printf("/challenges/%s"))(route.fields[0]);
        case 11:
            return toText(printf("/challenges/%s/pledges"))(route.fields[0]);
        case 12:
            return toText(printf("/challenges/%s/logs"))(route.fields[0]);
        case 3:
            return "/challenges/new";
        case 4:
            return toText(printf("/challenges/new/charity/%s"))(route.fields[0]);
        case 5:
            return "/profile";
        case 6:
            return "/profile/complete";
        case 7:
            return "/auth/callback";
        case 8:
            return "/register";
        case 9:
            return toText(printf("/verify/%s"))(route.fields[0]);
        case 10:
            return toText(printf("/pledges/%s"))(route.fields[0]);
        case 13:
            return "/privacy";
        case 14:
            return "/terms";
        case 15:
            return "/refunds";
        case 16:
            return "/flood-relief";
        default:
            return "/";
    }
}

/**
 * Parses an in-app path (query string ignored) into a Route. Anything that is not
 * an app route parses to Home.
 */
export function parsePath(path) {
    return parseUrl(ofArray(split(item(0, split(path, ["?"], undefined, 0)), ["/"], undefined, 1)));
}

const PostRegistrationStorage_storageKey = "you-thon-post-registration-route";

export function PostRegistrationStorage_save(route) {
    window.localStorage.setItem(PostRegistrationStorage_storageKey, formatPath(route));
}

export function PostRegistrationStorage_load() {
    return map(parsePath, ofNullable(window.localStorage.getItem(PostRegistrationStorage_storageKey)));
}

export function PostRegistrationStorage_clear() {
    window.localStorage.removeItem(PostRegistrationStorage_storageKey);
}

const PledgeFormIntentStorage_storageKey = "you-thon-pledge-form-intent";

export function PledgeFormIntentStorage_save(challengeId) {
    window.localStorage.setItem(PledgeFormIntentStorage_storageKey, challengeId);
}

export function PledgeFormIntentStorage_load() {
    return ofNullable(window.localStorage.getItem(PledgeFormIntentStorage_storageKey));
}

export function PledgeFormIntentStorage_clear() {
    window.localStorage.removeItem(PledgeFormIntentStorage_storageKey);
}

/**
 * The route to land on after the OIDC login round-trip. `returnPath` is the
 * path the login started from; it is re-parsed through `parseUrl`, so only an
 * in-app route can come back. Login started from Home or an auth page, or
 * without a return path, lands on Challenges.
 */
export function postLoginRoute(returnPath) {
    const parsed = map(parsePath, returnPath);
    let matchResult, route;
    if (parsed != null) {
        switch (parsed.tag) {
            case 0:
            case 7:
            case 8:
            case 9: {
                matchResult = 0;
                break;
            }
            default: {
                matchResult = 1;
                route = parsed;
            }
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return new ClientTypes_Route(1, []);
        default:
            return route;
    }
}

/**
 * The route a login should return to. Signing in from the sign-up pages
 * (/register, /verify) returns to the route sign-up started from, when one is stored.
 */
export function loginReturnRoute(current, postRegistration) {
    let matchResult, returnRoute;
    switch (current.tag) {
        case 8: {
            if (postRegistration != null) {
                matchResult = 0;
                returnRoute = postRegistration;
            }
            else {
                matchResult = 1;
            }
            break;
        }
        case 9: {
            if (postRegistration != null) {
                matchResult = 0;
                returnRoute = postRegistration;
            }
            else {
                matchResult = 1;
            }
            break;
        }
        default:
            matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return returnRoute;
        default:
            return current;
    }
}

export function currentRoute() {
    return parseUrl(RouterModule_urlSegments(window.location.pathname + window.location.search, 2));
}

export function navigate(route) {
    RouterModule_nav(singleton(formatPath(route)), 1, 2);
}

export function getQueryParam(name) {
    const search = window.location.search;
    const urlParams = new URLSearchParams(search);
    const value = urlParams.get(name);
    if (Operators_IsNull(value)) {
        return undefined;
    }
    else {
        return value;
    }
}

//# sourceMappingURL=Router.js.map
